/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system'
import { PROMETHEAN_BLUE } from '@prom/web-embers'

export const StyledThirdPartyButtons = styled('div')({
  button: {
    marginBottom: 16,
  },
  '&.ThirdPartyButtons': {
    '&-row': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
    },
  },
  '.ThirdPartyButton-vertical': {
    width: 84,
    display: 'flex',
    flexDirection: 'column',
    margin: '0 16px',
    padding: '12px 0 9px',
    textDecoration: 'none',
    alignItems: 'center',
    img: {
      width: 24,
      height: 24,
      marginBottom: 4,
    },
    '&:focus-visible': {
      outline: `2px solid ${PROMETHEAN_BLUE}`,
      outlineOffset: -2,
    },
  },
})
